export default __webpack_public_path__ + "static/media/header-nps.b94fd3f2.svg";